module.exports = __webpack_public_path__ + "static/banner-cofunders-7436ed9e86914188d503eb4f67fb6c30.jpg";